import { api } from '../lib/api';

export interface PropertyCardData {
  id: string;
  code: string;
  type: string;
  typeLabel: string;
  title: string;
  bedrooms: number | null;
  bathrooms: number | null;
  parkingSpaces: number | null;
  totalArea: number | null;
  builtArea: number | null;
  usableArea: number | null;
  salePrice: number | null;
  rentPrice: number | null;
  condoFee: number | null;
  iptu: number | null;
  neighborhood: string;
  city: string;
  state: string;
  cover: string | null;
}

export interface PropertyDetail extends PropertyCardData {
  description: string;
  complement: string;
  street: string;
  number: string;
  zipCode: string;
  latitude: number | null;
  longitude: number | null;
  characteristics: any;
  photos: string[];
}

export interface SiteInfo {
  name: string;
  creci?: string;
  email?: string;
  phone?: string;
  whatsapp?: string;
  address?: {
    street?: string;
    number?: string;
    complement?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zipCode?: string;
  };
  logoUrl?: string | null;
  faviconUrl?: string | null;
  sizes?: BrandingSizes | null;
  content?: {
    about?: string;
    privacy?: string;
    cookies?: string;
    terms?: string;
    dpoName?: string;
    dpoEmail?: string;
    businessHours?: string;
    permuta?: string;
  } | null;
  properties?: number;
}

export interface BrandingSizes {
  headerLogoHeight: number;
  footerLogoHeight: number;
  systemLogoHeight: number;
  loginLogoWidth: number;
  watermarkScale: number;
  watermarkOpacity: number;
}

export interface ListMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export async function fetchSiteInfo(): Promise<SiteInfo> {
  const { data } = await api.get('/public/site');
  return data;
}

export async function fetchFeatured(): Promise<{ rent: PropertyCardData[]; sale: PropertyCardData[] }> {
  const { data } = await api.get('/public/featured');
  return data;
}

export async function fetchProperties(
  params: Record<string, string | number | undefined>,
): Promise<{ data: PropertyCardData[]; meta: ListMeta }> {
  const clean: Record<string, string> = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== '' && v !== null) clean[k] = String(v);
  });
  const { data } = await api.get('/public/properties', { params: clean });
  return data;
}

export async function fetchProperty(id: string): Promise<PropertyDetail> {
  const { data } = await api.get(`/public/properties/${id}`);
  return data;
}

export function brl(value?: number | null): string {
  if (value == null) return '';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Monta o link do WhatsApp com mensagem opcional. */
export function whatsappLink(digits?: string, message?: string): string {
  const d = (digits || '').replace(/\D/g, '');
  const num = d.length > 0 && !d.startsWith('55') ? `55${d}` : d;
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${num}${text}`;
}
